class MathUtilsContainer {
    RandomNumberBetween(minimum: number, maximum: number) {
        // includes minimum and maximum numbers
        return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
    }

    IfIsNaN(value: number, valueIfNaN: number) {
        if (isNaN(value)) {
            return valueIfNaN;
        } else {
            return value;
        }
    }

    IsValidNumber(numberString: string) {
        return !isNaN(Number(numberString));
    }

    Romanize(input: number) {
        if (isNaN(input)) return NaN;

        var digits = String(+input).split(""),
            key = [
                "",
                "C",
                "CC",
                "CCC",
                "CD",
                "D",
                "DC",
                "DCC",
                "DCCC",
                "CM",
                "",
                "X",
                "XX",
                "XXX",
                "XL",
                "L",
                "LX",
                "LXX",
                "LXXX",
                "XC",
                "",
                "I",
                "II",
                "III",
                "IV",
                "V",
                "VI",
                "VII",
                "VIII",
                "IX",
            ],
            roman = "",
            i = 3;

        while (i--) roman = (key[+digits.pop()! + i * 10] || "") + roman;

        return Array(+digits.join("") + 1).join("M") + roman;
    }
}

export const MathUtils = new MathUtilsContainer();
